import { Table } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const TableIcon = createLucideIcon(Table);
